<template>
  <!-- 公用组件 报表所有表格封装组件  -->
  <div>
    <!-- 业务草稿、经营历程表格、订单报警 -->
    <template v-if="$attrs.pargam.Model=='Draft'||$attrs.pargam.Model=='BusinessProcess'||$attrs.pargam.Model=='OrderWarn' || $attrs.pargam.Model=='business'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="invalidRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left" :key="Math.random()">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <vxe-table-column width="180" v-if="$attrs.pargam.Model!='business'" align="center" title="操作" fixed="left" :key="Math.random()">
                <template v-slot="{row,rowIndex}">
                    <blockquote v-if="row.ButtonType==1">
                        <el-button @click.native.prevent="completeRow(rowIndex,row)" type="text" size="small">强制完成</el-button>
                        <el-button @click.native.prevent="copyRow(rowIndex,row)" type="text" size="small">复制</el-button>
                        <el-button @click.native.prevent="deleteRow(rowIndex,row)" type="text" size="small">删除</el-button>
                    </blockquote>
                    <blockquote v-if="row.ButtonType==2">
                        <el-button @click.native.prevent="completeRow(rowIndex,row)" type="text" size="small">强制完成</el-button>
                        <el-button @click.native.prevent="copyRow(rowIndex,row)" type="text" size="small">复制</el-button>
                        <el-button @click.native.prevent="deleteRow(rowIndex,row)" type="text" size="small" disabled>删除</el-button>
                    </blockquote>    
                    <blockquote v-if="row.ButtonType==3">
                        <el-button @click.native.prevent="completeRow(rowIndex,row)" type="text" size="small" disabled>强制完成</el-button>
                        <el-button @click.native.prevent="copyRow(rowIndex,row)" type="text" size="small">复制</el-button>
                        <el-button @click.native.prevent="deleteRow(rowIndex,row)" type="text" size="small" disabled>删除</el-button>
                    </blockquote>  
                    <blockquote v-if="row.ButtonType==4">
                        <el-button @click.native.prevent="invalidRow(row)" type="text" size="small">红冲作废</el-button>
                        <el-button @click.native.prevent="copyRow(rowIndex,row)" type="text" size="small">复制</el-button>
                        <el-button @click.native.prevent="deleteRow(rowIndex,row)" type="text" size="small" disabled>删除</el-button>
                    </blockquote>
                    <blockquote v-if="row.ButtonType==5">
                        <el-button @click.native.prevent="invalidRow(row)" type="text" size="small" disabled>红冲作废</el-button>
                        <el-button @click.native.prevent="copyRow(rowIndex,row)" type="text" size="small">复制</el-button>
                        <el-button @click.native.prevent="deleteRow(rowIndex,row)" type="text" size="small" disabled>删除</el-button>
                    </blockquote>
                    <blockquote v-if="row.ButtonType==6">
                        <el-button @click.native.prevent="invalidRow(row)" type="text" size="small" disabled>红冲作废</el-button>
                        <el-button @click.native.prevent="copyRow(rowIndex,row)" type="text" size="small" disabled>复制</el-button>
                        <el-button @click.native.prevent="deleteRow(rowIndex,row)" type="text" size="small" disabled>删除</el-button>
                    </blockquote>   
                    <blockquote v-if="row.ButtonType==7">
                        <el-button @click.native.prevent="copyRow(rowIndex,row)" type="text" size="small">复制</el-button>
                        <el-button @click.native.prevent="deleteRow(rowIndex,row)" type="text" size="small">删除</el-button>
                    </blockquote>
                </template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Key=='FullName'||item.Key=='BaseCode'&& item.Show == true" align="center" :width="item.Width==''?'180':item.Width" :field="item.Key" :title="item.Rename" :BaseNo="item.BaseNo" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-input size="mini" type="text" :ref="rowIndex+'A'+columnIndex" @dblclick.native="dbClick(rowIndex)" @keydown.enter.native="enterKey(rowIndex,item,columnIndex)"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-button v-if="item.Key == 'Number'" @click.native.prevent="invalidRow(row)" type="text" size="small" :style="{color:row.RedOld=='T'?'red':''}">{{row[item.Key]}}</el-button>
                        <span v-else class="span_inner_sty" :style="{color:row.RedOld=='T'?'red':''}">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 当前库存表格 -->
    <template v-if="$attrs.pargam.Model=='CurrentStorage'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">

            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="index == 0" type="index" align="center" width="50" fixed="left" :key="'a'+index">
                    <template v-slot:header="{ column }">
                        <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                    </template>
                    <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
                </vxe-table-column>
                <vxe-table-column v-if="index == 0" width="130" align="center" title="操作" fixed="left" :key="'b'+index">
                    <template v-slot="{row,rowIndex}">
                        <el-button @click.native.prevent="detailRow(row)" type="text" size="small">明细</el-button>
                        <el-dropdown trigger="click" style="margin-left:10px;">
                            <span class="el-dropdown-link">
                                <el-button type="text" size="mini">更多</el-button>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <el-button @click.native.prevent="Distribution(row)" type="text" size="small">库存分布</el-button>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <el-button @click.native.prevent="clickOtherBtn(row,1)" type="text" size="small">序列号库存</el-button>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <el-button @click.native.prevent="clickOtherBtn(row,2)" type="text" size="small">批次库存</el-button>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        
                    </template>
                </vxe-table-column>
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 库存分布表表格 -->
    <template v-if="$attrs.pargam.Model=='StockDistribut'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="detailRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column type="index" align="center" width="50" fixed="left" v-if="index == 0" :key="index+'a'">
                    <template v-slot:header="{ column }">
                        <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                    </template>
                    <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
                </vxe-table-column>
                <vxe-table-column width="130" align="center" title="操作" fixed="left" v-if="index == 0" :key="index+'b'">
                    <template v-slot="{row,rowIndex}">
                        <el-button @click.native.prevent="detailRow(row)" type="text" size="small">明细</el-button>
                    </template>
                </vxe-table-column>
                <vxe-table-column width="60" align="center" title="类型" fixed="left" v-if="index == 0" :key="index+'c'">
                    <template v-slot="{ row,rowIndex}">
                        <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                    </template>
                </vxe-table-column>
                <vxe-table-column  width="60" align="center" title="图片" v-if="index == 0 && isShowPic" :key="index+'d'">
                    <template v-slot="{ row,rowIndex}">
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
                        <img
                        v-if="row.ImageUrl"
                        :src="row.ImageUrl"
                        style="width:26px;height: 26px;display:block;"
                        @click="imgclick(row.ImageUrl)"
                        />
                        <span v-else-if="row.FullName!='' && row.BaseCode!='' && !row.ImageUrl"></span>
                    </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 库存汇总表 -->
    <template v-if="$attrs.pargam.Model=='GatherStock'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="dbClickRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column type="index" align="center" width="50" fixed="left" v-if="index == 0" :key="index+'a'">
                    <template v-slot:header="{ row, column }">
                        <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon()"></i>
                    </template>
                    <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
                </vxe-table-column>
                <vxe-table-column width="130" align="center" title="操作" fixed="left" v-if="index == 0" :key="index+'b'">
                    <template v-slot="{row,rowIndex}">
                        <el-button @click.native.prevent="detailRow(row)" type="text" size="small">明细</el-button>
                    </template>
                </vxe-table-column>
                <vxe-table-column width="60" align="center" title="类型" fixed="left"  v-if="index == 0" :key="index+'c'">
                    <template v-slot="{ row,rowIndex}">
                        <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                    </template>
                </vxe-table-column>
                <vxe-table-column width="60" align="center" title="图片" v-if="index == 0 && isShowPic" :key="index+'d'">
                    <template v-slot="{ row,rowIndex}">
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
                        <img
                        v-if="row.ImageUrl"
                        :src="row.ImageUrl"
                        style="width:26px;height: 26px;display:block;"
                        @click="imgclick(row.ImageUrl)"
                        />
                        <span v-else-if="row.FullName!='' && row.BaseCode!='' && !row.ImageUrl"></span>
                    </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 报损报溢统计表、其他出入库统计 -->
    <template v-if="$attrs.pargam.Model=='ReportStatis'||$attrs.pargam.Model=='OtherInOutStatis'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="dbClickRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column type="index" align="center" width="50" fixed="left" v-if="index == 0" :key="index+'a'">
                    <template v-slot:header="{ row, column }">
                        <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon()"></i>
                    </template>
                    <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
                </vxe-table-column>
                <vxe-table-column width="60" align="center" title="类型" fixed="left"  v-if="index == 0" :key="index+'c'">
                    <template v-slot="{ row,rowIndex}">
                        <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                    </template>
                </vxe-table-column>
                <vxe-table-column width="60" align="center" title="图片" v-if="index == 0 && isShowPic" :key="index+'d'">
                    <template v-slot="{ row,rowIndex}">
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
                        <img
                        v-if="row.ImageUrl"
                        :src="row.ImageUrl"
                        style="width:26px;height: 26px;display:block;"
                        @click="imgclick(row.ImageUrl)"
                        />
                        <span v-else-if="row.FullName!='' && row.BaseCode!='' && !row.ImageUrl"></span>
                    </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 商品出入库明细表格 -->
    <template v-if="$attrs.pargam.Model=='StockDistributDetailed'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="invalidRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left" :key="Math.random()">
                <template v-slot:header="{ column }">
                    <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="tableConfigShow=true"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-button v-if="item.Key == 'Number'" @click.native.prevent="invalidRow(row)" type="text" size="small" :style="{color:row.RedOld=='T'?'red':''}">{{row[item.Key]}}</el-button>
                        <span v-else class="span_inner_sty" :style="{color:row.RedOld=='T'?'red':''}">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 商品销售统计、商品采购统计 -->
    <template v-if="$attrs.pargam.Model=='SaleStats'||$attrs.pargam.Model=='BuyStats'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="dbClickRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
        :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left" :key="Math.random()">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <vxe-table-column width="130" align="center" title="操作" fixed="left" :key="Math.random()">
                <template v-slot="{row,rowIndex}">
                    <el-button @click.native.prevent="detailRow(row)" type="text" size="small">明细</el-button>
                </template>
            </vxe-table-column>
            
            <vxe-table-column width="60" align="center" title="图片"  fixed="left" v-if="isShowPic">
                <template v-slot="{ row,rowIndex}">
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
                        <img
                        v-if="row.ImageUrl"
                        :src="row.ImageUrl"
                        style="width:26px;height: 26px;display:block;"
                        @click="imgclick(row.ImageUrl)"
                        />
                        <span v-else-if="row.FullName!='' && row.BaseCode!='' && !row.ImageUrl"></span>
                    </div>
                </template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column width="60" align="center" :key="index+'s'" title="类型"  fixed="left" v-if="index==0">
                    <template v-slot="{ row,rowIndex}">
                        <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                    </template>
                </vxe-table-column>
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 商品销售明细、商品采购明细、销售成本统计 -->
    <template v-if="$attrs.pargam.Model=='SaleDetail'||$attrs.pargam.Model=='BuyDetail'||$attrs.pargam.Model=='SaleCost'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="invalidRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
        :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Key == 'Number' && item.Show == true" :title="item.Rename" :width="item.Width==''?'200':item.Width" :field="item.Key" align="center" fixed="left" :key="index">
                    <template v-slot="{ row,rowIndex}">
                        <el-button @click.native.prevent="invalidRow(row)" type="text" size="small">{{row[item.Key]}}</el-button>
                    </template>
                </vxe-table-column>
                <vxe-table-column v-else-if="item.Key !== 'Number' && item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-input size="mini" v-if="row.VchType!=='' &&item.Key=='ThisTotal'" type="text" class="input_sty" v-model="row[item.Key]" @focus="inputFocus($event)"
                        @input="row[item.Key]=row[item.Key].replace(/^[^\-\d]*([\-\d]?\d*(?:\.\d{0,6})?).*$/g, '$1');"></el-input>
                        <span  class="span_inner_sty"  v-else>{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 客户销售统计、供应商采购统计 -->
    <template v-if="$attrs.pargam.Model=='ClientSaleStats'||$attrs.pargam.Model=='ClientBuyStats'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="dbClickRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
        :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left" :key="Math.random()">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <vxe-table-column width="130" align="center" title="操作" fixed="left" :key="Math.random()">
                <template v-slot="{row,rowIndex}">
                    <el-button @click.native.prevent="detailRow(row)" type="text" size="small">商品分布</el-button>
                </template>
            </vxe-table-column>
            <vxe-table-column width="60" align="center" title="类型" fixed="left">
                <template v-slot="{ row,rowIndex}">
                    <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                </template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 销售订单统计、销售订单分析 -->
    <template v-if="$attrs.pargam.Model=='SaleOrderStatis'||$attrs.pargam.Model=='BuyOrderStatis'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod"  @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
        :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <vxe-table-column width="60" align="center" title="图片" v-if="isShowPic">
                <template v-slot="{ row }">
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
                        <img
                        v-if="row.ImageUrl"
                        :src="row.ImageUrl"
                        style="width:26px;height: 26px;display:block;"
                        @click="imgclick(row.ImageUrl)"
                        />
                        <span v-else-if="row.FullName!='' && row.BaseCode!='' && !row.ImageUrl"></span>
                    </div>
                </template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 采购价格波动分析、序列号查询报表、序列号库存报表、批次库存报表 -->
    <template v-if="$attrs.pargam.Model=='PriceRange'||$attrs.pargam.Model=='SerialNoQuery'||$attrs.pargam.Model=='SerialNoStock'||$attrs.pargam.Model=='JobNumberFind'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer  @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}">
            <vxe-table-column type="index" align="center" width="50">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <vxe-table-column width="60" align="center" title="图片" v-if="isShowPic">
                <template v-slot="{ row,rowIndex}">
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
                        <img
                        v-if="row.ImageUrl"
                        :src="row.ImageUrl"
                        style="width:26px;height: 26px;display:block;"
                        @click="imgclick(row.ImageUrl)"
                        />
                        <span v-else-if="row.FullName!='' && row.BaseCode!='' && !row.ImageUrl"></span>
                    </div>
                </template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 现金银行统计、费用统计、收入统计、客户应收统计、供应商应付统计、欠款分布统计、回款分布统计 -->
    <template v-if="$attrs.pargam.Model=='CashBankStatis'||$attrs.pargam.Model=='CostStatis'||$attrs.pargam.Model=='IncomeStatis'||$attrs.pargam.Model=='CustomerReceive'||$attrs.pargam.Model=='SupplierPay'||$attrs.pargam.Model=='ArrearsDistribution'||$attrs.pargam.Model=='BackDistribution'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="dbClickRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
        :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left" :key="Math.random()">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <vxe-table-column width="130" align="center" title="操作" fixed="left" :key="Math.random()">
                <template v-slot="{row,rowIndex}">
                    <el-button @click.native.prevent="detailRow(row)" type="text" size="small">明细</el-button>
                </template>
            </vxe-table-column>
            <vxe-table-column width="60" align="center" title="类型" fixed="left">
                <template v-slot="{ row,rowIndex}">
                    <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                </template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 现金银行统计明细、费用统计明细、收入统计明细、收款金额明细、付款金额明细、职员应收统计明细、职员回款明细 -->
    <template v-if="$attrs.pargam.Model=='CashBankDetail'||$attrs.pargam.Model=='CostStatisDetail'||$attrs.pargam.Model=='IncomeStatisDetail'||$attrs.pargam.Model=='ReceiveDetail'||$attrs.pargam.Model=='PayDetail'||$attrs.pargam.Model=='PersonReceiveDetail'||$attrs.pargam.Model=='PersonBackDetail'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="invalidRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
      :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left" :key="Math.random()">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Key=='FullName'||item.Key=='BaseCode'&& item.Show == true" align="center" :width="item.Width==''?'180':item.Width" :field="item.Key" :title="item.Rename" :BaseNo="item.BaseNo" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-input size="mini" type="text" :ref="rowIndex+'A'+columnIndex" @dblclick.native="dbClick(rowIndex)" @keydown.enter.native="enterKey(rowIndex,item,columnIndex)"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-button v-if="item.Key == 'Number'" @click.native.prevent="invalidRow(row)" type="text" size="small" :style="{color:row.RedOld=='T'?'red':''}">{{row[item.Key]}}</el-button>
                        <span v-else class="span_inner_sty" :style="{color:row.RedOld=='T'?'red':''}">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    <!-- 职员应收统计、职员回款统计 -->
    <template v-if="$attrs.pargam.Model=='PersonReceive'||$attrs.pargam.Model=='PersonReceiveMoney'">
        <vxe-table ref="xTable" border resizable size="mini" :height="tableHeight" :data="data" highlight-hover-row highlight-current-row show-overflow show-header-overflow :keyboard-config="{isArrow: true}" show-footer :footer-method="footerMethod" @cell-dblclick="dbClickRow($event.row)" @resizable-change="resizablechange"
          :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0',fontWeight: 'bold'}" :footer-row-style="{ background:'#eef1f6',color:'#000',fontSize:'14px',height:'30px',padding:'0',}"
        :footer-cell-style="{ background:'#fff',color:'#000',fontSize:'14px',height:'30px',padding:'0',}">
            <vxe-table-column type="index" align="center" width="50" fixed="left" :key="Math.random()">
                <template v-slot:header="{ column }">
                    <i :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                </template>
                <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
            </vxe-table-column>
            <vxe-table-column width="130" align="center" title="操作" fixed="left" :key="Math.random()">
                <template v-slot="{row,rowIndex}">
                    <el-button @click.native.prevent="detailRow(row)" type="text" size="small">明细</el-button>
                    <el-button @click.native.prevent="Distribution(row)" type="text" size="small">{{$attrs.pargam.Model=='PersonReceive'?'欠款分布':'回款分布'}}</el-button>
                </template>
            </vxe-table-column>
            <vxe-table-column width="60" align="center" title="类型" fixed="left">
                <template v-slot="{ row,rowIndex}">
                    <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                </template>
            </vxe-table-column>
            <template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Show == true" :title="item.Rename" align="center" :width="item.Width==''?'200':item.Width" :BaseNo="item.BaseNo" :field="item.Key" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <span class="span_inner_sty">{{row[item.Key]}}</span>
                    </template>
                </vxe-table-column>
            </template>
        </vxe-table>
    </template>
    
    <!-- table表格配置弹出框 -->
    <HeaderElastic v-if="$attrs.pargam.Model=='PayMoney'||$attrs.pargam.Model=='ReceiveMoney'" :show.sync="tableConfigShow" :tableData="ConfigData" v-bind="$attrs" v-on="$listeners" @restoreDefault="restoreDefault"/>
    <TableConfigDialog v-else :show.sync="tableConfigShow" :tableData="ConfigData" v-bind="$attrs" v-on="$listeners" @restoreDefault="restoreDefault"/>
    <!-- 查看图片弹出框 -->
    <el-dialog :visible.sync="dialogVisible" class="image_sty">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 引入工具类方法
import tool from "@/utils/tool.js";
// 事件日期方法
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
    data() {
        return {
            // 状态值
			tableConfigShow:false,//是否显示表头配置弹出框
			ConfigData: this.tableConfigData, //表头配置项数据
            data:this.tableData,//表格数据
            isInner: true,//标记表格表头显示icon
            dialogVisible: false,//查看图片弹出
            dialogImageUrl: "",//高清图片链接
        };
    },
    props:{
		tableData: Array,//表格数据
        tableConfigData: Array, //表头配置项数据
        // 表格高度
        tableHeight:{
            type:String,
            default:'420'
        },
        // 开始时间
        startDateVal1:{
            type:String,
            default:()=>moment().startOf('month').format("YYYY-MM-DD")
        },
        // 开始时间
        endDateVal1:{
            type:String,
            default:()=>moment().format("YYYY-MM-DD")
        },
        // 仓库（当前库存）
        warehouseVal1:{
            FullName: '' , 
            KtypeId: Number('') 
        }
    },
    watch:{
        // 表格数据
        tableData:{
            handler(newValue, oldValue) {
                let that = this;
                this.data = newValue;
                console.log(this.data);
                // 更新表格数据
                that.$refs.xTable.refreshColumn();
                that.$refs.xTable.refreshData();
                that.$refs.xTable.updateData();
                that.$refs.xTable.recalculate();
                // 更新合计数据
                that.$refs.xTable.updateFooter();

            },
            deep: true
        },
        // 表头配置数据
        tableConfigData:{
            handler(newValue, oldValue) {
                let that = this;
                this.ConfigData = newValue;
            setTimeout(function(){
                    // console.log(newValue)
                that.$refs.xTable.refreshColumn();
                that.$refs.xTable.refreshData();
                // // 更新表格数据
                that.$refs.xTable.updateData();
                that.$refs.xTable.recalculate()
            },200)
            },
             deep: true,
            immediate: true
            // immediate:true
        },
    },
    methods:{
        // 点击商品图片查看详细图
        imgclick(ImageUrl) {
            this.dialogImageUrl = ImageUrl;
            this.dialogVisible = true;
        },
        // 双击打开单据查看详情
        invalidRow(data){
            if(!data.DataPriv.getone){
                this.$message({
                    message: '您没有查看单据权限',
                    type: 'warning'
                });
                return
            }
            // console.log(data,66666);
            let item = {
                    title: tool.findOrderName(data.VchType).pageName,
                    component: tool.findOrderName(data.VchType).pageRoute,
                    menuId: this.$attrs.pargam.Model + 'invalidRow' + tool.findOrderName(data.VchType).pageRoute + Math.random(),
                    query:{}
                };
            // type：0：代表过草稿或新单（可填写）、1：代表过账或者已红冲（不可填写） dist:0为普通页面跳转过来的，1为红冲等跳转过来的，2为复制跳转过来的
            if(data.VchType == 7 ||data.VchType == 8){
                this.$tab.push(item, { VchCode: data.VchCode,VchType:data.VchType,type:data.Draft,dist:3});
            }else{
                this.$tab.push(item, { VchCode: data.VchCode,VchType:data.VchType,type:data.Draft,dist:1});
            }
        },
        // 点击复制
        copyRow(index,data){
            if(!data.DataPriv.getone && !data.DataPriv.copy){
                this.$message({
                    message: '您没有复制权限',
                    type: 'warning'
                });
                return
            }
            let item = {
                    title: tool.findOrderName(data.VchType).pageName,
                    component: tool.findOrderName(data.VchType).pageRoute,
                    menuId: 'draft' + 'copyRow' + tool.findOrderName(data.VchType).pageRoute + Math.random(),
                    query:{}
                };
            this.$tab.push(item, { VchCode: data.VchCode,VchType:data.VchType,type:data.Draft,dist:2});
        },
        // 删除某张单据
        deleteRow(index,data){
            if(!data.DataPriv.deldraft){
                this.$message({
                    message: '您没有删除他人单据权限',
                    type: 'warning'
                });
                return
            }
            let params = {
                user_id:tool.getLocal("userid"),//用户ID
                session_id:tool.getLocal("sessionid"),//用户凭证
                VchCode:data.VchCode,//单据ID
            };
            this.request.post('/index.php/index/Delete_Bill/DeleteBill', {'jparams' : JSON.stringify(params)})
            .then(res => {
            // 接收后端发送回来的数据
                if(res.status==0){
                    this.$message({
                        message: res.description,
                        type: 'success'
                    });
                    // 更新表格数据
                    this.$emit('updateData')
                }else{
                    this.$message({
                        message: '删除单据失败',
                        type: 'warning'
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 点击强制完成
        completeRow(index,data){
            // 强制完成权限
            if(!data.DataPriv.forcecomplete){
                this.$message({
                    message: '您没有强制完成权限',
                    type: 'warning'
                });
                return
            }
            let params = {
                user_id:tool.getLocal("userid"),//用户ID
                session_id:tool.getLocal("sessionid"),//用户凭证
                VchCode:data.VchCode,//单据ID
            };
            this.request.post('/index.php/index/Force_Complete/ForceComplete', {'jparams' : JSON.stringify(params)})
            .then(res => {
            // 接收后端发送回来的数据
                if(res.status==0){
                    this.$message({
                        message: res.description,
                        type: 'success'
                    });
                    // 更新表格数据
                    this.$emit('updateData')
                }else{
                    this.$message({
                        message: '删除单据失败',
                        type: 'warning'
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 点击明细
        detailRow(data){
            let item = {};
            let pageParams = { data:data,dist:1,startDateVal1:this.startDateVal1,endDateVal1:this.endDateVal1};
            switch (this.$attrs.pargam.Model) {
                case 'SaleStats'://商品销售统计
                    item = {
                        title: '商品销售明细',
                        component: 'goodssaledetail',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'BuyStats'://商品采购统计
                    item = {
                        title: '商品采购明细',
                        component: 'goodsbuydetail',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'StockDistributDetailed'://商品出入库明细
                    item = {
                        title: '商品出入库明细',
                        component: 'inventorydetail',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'ClientSaleStats'://客户销售统计
                    item = {
                        title: '商品销售统计',
                        component: 'salestatistics',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'ClientBuyStats'://供应商采购统计
                    item = {
                        title: '商品采购统计',
                        component: 'procurementstatistics',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'CashBankStatis'://现金银行统计
                    // 跳转现金银行统计明细
                    item = {
                        title: '现金银行统计明细',
                        component: 'cashbankdetails',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'CostStatis'://费用统计
                    // 跳转费用统计明细
                    item = {
                        title: '费用统计明细',
                        component: 'coststatisticsdetail',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'IncomeStatis'://收入统计
                    // 跳转收入统计明细
                    item = {
                        title: '收入统计明细',
                        component: 'revenuestatisticsdetail',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:pageParams
                    };
                    break;
                case 'CustomerReceive'://客户应收统计
                    // 跳转往来对账
                    item = {
                        title: '往来对账',
                        component: 'reconciliation',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'SupplierPay'://供应商应付统计
                    // 跳转往来对账
                    item = {
                        title: '往来对账',
                        component: 'reconciliation',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'PersonReceive'://职员应收统计
                    // 跳转职员应收统计明细
                    item = {
                        title: '职员应收统计明细',
                        component: 'staffreceivabledetails',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'PersonReceiveMoney'://职员回款统计
                    // 跳转职员回款统计明细
                    item = {
                        title: '职员回款统计明细',
                        component: 'staffreturnmoneydetails',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'ArrearsDistribution'://欠款分布统计
                    // 跳转职员应收统计明细
                    item = {
                        title: '职员应收统计明细',
                        component: 'staffreceivabledetails',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 'BackDistribution'://回款分布统计
                    // 跳转职员回款明细
                    item = {
                        title: '职员回款明细',
                        component: 'staffreturnmoneydetails',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                default:
                    item = {
                        title: '商品出入库明细',
                        component: 'inventorydetail',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                }
            this.$tab.push(item, pageParams);
        },
        // 点击库存分布
        Distribution(data){
            // type：表示从哪个页面跳转过去的
            let item = {};
            let pageParams = { data:data,dist:1};
            switch (this.$attrs.pargam.Model) {
                case 'CurrentStorage'://当前库存分布表
                    // 跳转库存分布明细
                    item = {
                        title: '库存分布',
                        component: 'inventorydistribution',
                        menuId: this.$attrs.pargam.Model + 'Distribution' + Math.random(),
                        query:{}
                    };
                    break;
                case 'PersonReceive'://职员应收统计
                    // 跳转欠款分布
                    item = {
                        title: '欠款分布',
                        component: 'debtdistributionstatistics',
                        menuId: this.$attrs.pargam.Model + 'Distribution' + Math.random(),
                        query:{}
                    };
                    pageParams = { data:data,dist:1,startDateVal1:this.startDateVal1,endDateVal1:this.endDateVal1};
                    break;
                case 'PersonReceiveMoney'://职员回款统计
                    // 跳转回款分布
                    item = {
                        title: '回款分布',
                        component: 'recedistributionstatistics',
                        menuId: this.$attrs.pargam.Model + 'Distribution' + Math.random(),
                        query:{}
                    };
                    pageParams = { data:data,dist:1,startDateVal1:this.startDateVal1,endDateVal1:this.endDateVal1};
                    break;
                default:
                    item = {
                        title: '库存分布',
                        component: 'inventorydistribution',
                        menuId: this.$attrs.pargam.Model + 'Distribution' + Math.random(),
                        query:{}
                    };
                    break;
            }
            this.$tab.push(item, pageParams);
        },
        // 点击更多中的其他按钮 type:1-序列号库存，2-批次号库存
        clickOtherBtn(data,type){
            let item = {};
            let pageParams = { data:data,dist:1,startDateVal1:this.startDateVal1,endDateVal1:this.endDateVal1,warehouseVal1:this.warehouseVal1};
            switch (type) {
                case 1:// 跳转序列号库存报表
                    item = {
                        title: '序列号库存报表',
                        component: 'serialnostock',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                case 2:// 跳转批次库存
                    item = {
                        title: '批次库存报表',
                        component: 'jobnumberfind',
                        menuId: this.$attrs.pargam.Model + 'detailRow' + Math.random(),
                        query:{}
                    };
                    break;
                default:
                    break;
            }
            this.$tab.push(item, pageParams);
        },
        // 双击某行
        dbClickRow(row){
            // console.log(row)
            if (row.IsDir) {
                this.isInner = false;
                this.$emit("rowdblclick", row);
            }else{
                // 判断是否是库存汇总表（跳商品出入库明细）、客户销售统计（跳商品分布）、供应商采购统计（跳商品分布） 双击，如果是库存汇总表则跳转 商品出入库明细
                if (this.$attrs.pargam.Model=='GatherStock'||this.$attrs.pargam.Model=='ClientSaleStats'||this.$attrs.pargam.Model=='ClientBuyStats') {
                    // 跳转页面 进入商品出入库明细
                    this.detailRow(row)
                }else{
                    // 其他
                }
            }
        },
        //点击图标事件
        clickIcon() {
            if (!this.isInner) {
                this.$emit("clickIcon");
                this.isInner = true;
            } else {
                this.tableConfigShow = true;
            }
        },
        // 聚焦选中input全部
        inputFocus() {
            event.currentTarget.select();
        },
        // 恢复表格默认
        restoreDefault(data){
            this.ConfigData = data;
        },
        // 拖动列宽事件
        resizablechange({column}) {
            if(this.backBaseNo(column.property)){
                let jparams = {
                    user_id: tool.getLocal("userid"),
                    session_id: tool.getLocal("sessionid"),
                    Model: this.$attrs.pargam.Model,
                    data: [
                        {
                            BaseNo:this.backBaseNo(column.property).BaseNo,
                            Width: column.resizeWidth
                        }
                    ]
                };
                this.request.post("/index/Settings/modify_function_fields", { jparams: JSON.stringify(jparams)})
                .then(res => {

                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        // 表尾合计方法
        footerMethod ({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计'
                    }
                    return this.$attrs.footerMet[column.property];
                })
            ]
        },

        // 过滤出当拉动的列的BaseNo
        backBaseNo(columnPro){
            return this.ConfigData.find(item=>item.Key == columnPro);
        },
    },
    computed:{
        isShowPic(){
            return tool.getLocal("get_config").showPic;
        }
    },
    mounted(){
    }
};

</script>

<style lang="less">
/deep/ .vxe-table .vxe-cell {
  padding: 0 !important;
}
/deep/ .vxe-table .vxe-body--column.col--ellipsis,
.vxe-table.vxe-editable .vxe-body--column,
.vxe-table .vxe-footer--column.col--ellipsis,
.vxe-table .vxe-header--column.col--ellipsis {
  height: 31px;
}
//滚动条的宽度
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #ccc;
}
:-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
}

</style>


// WEBPACK FOOTER //
// src/components/Table/MaReportTable/MaReportTable.vue